export default "/images/vendor/flag-icon-css/flags/4x3/gd.svg?9357b33dc4ff2614d2dd34386eff33ad";